module.exports = __webpack_public_path__ + "static/flowers-3bc6ec7749fd7faaf17c1e52da8581fc.png";